import styled from "styled-components";

const StyledEPayV2 = styled.form`
  display: none;
`;

export { StyledEPayV2 };
